// extracted by mini-css-extract-plugin
export default {"space":"styles_space__gDVWV","half-space":"styles_half-space__AOSu+"};